import instance from './request'
import apiurl from './apiurl'
import axios from 'axios'
const { user, station } = apiurl
// 登录
export const userLogin = (params) => instance.post(user.login, params)

// 管理员列表
export const adminList = () => instance.get('/admin')

// 站点列表
export const getStationList = (params) => instance.get(station.list, params)

// 优惠券列表
export const discountList = (params) => instance.get('/coupon', params)

// 优惠券创建
export const discountCreate = (params) => instance.post('/coupon', params)

// 优惠券详情
export const discountDetail = (params) => instance.get('/coupon/' + params.id)

// 商户列表
export const merchantList = () => instance.get('/merchant')

// 兴趣列表
export const tasteList = () => instance.get('/taste')

// 兴趣创建
export const tasteCreate = (params) => instance.post('/taste', params)

// 兴趣修改
export const tasteEdit = (params) => instance.put('/taste/' + params.id, params)

// 商品列表
export const getGoodList = (params) => instance.get('/goods', params)

// 分销人员列表
export const salesmanList = (params) => instance.get('/agent', params)

// 分销人员详情
export const agentDetail = (params) => instance.get('/agent/' + params.id)

// 分销人员审核
export const auditUser = (params) => instance.put('/agent/' + params.id, {status: params.status})
// 分销统计
export const agentCount = (params) => instance.get('/agent/agentCount', params)
// 分销人员冻结状态
export const frozen = (params) => instance.put(`/agent/status/${params.status}/` + params.id)
// 订单列表
export const orderList = (params) => instance.get('/order', params)

// 订单删除
export const orderDelete = (params) => instance.delete('/order/' + params.id)

// 订单详情
export const orderDetail = (params) => instance.get('/order/' + params.id)
// 商品列表
// export const getGoodList = (params) => instance.get('/goods/', params)
// 商品详情
export const getGoodDetail = (params) =>instance.get('/goods/' + params.id)
// 商品分类列表
export const goodsCategoryList = (params) => instance.get('/goodsCategory', params)
// 商品日志
export const goodsLog = (id, params) => instance.get(`/goodsLog/${id}`, params)

// 新建商品分类
export const goodsTypeSave = (params, isEdit) => {
  if (isEdit) {
    return instance.put('/goodsCategory/' + params.id, params)
  } else {
    return instance.post('/goodsCategory', params)
  }
}

// 商品分类修改状态
export const goodsTypeChange = (params) => instance.put('/goodsCategory/disabled', params)

// 商品分类详情
export const goodsTypeDetail = (params) => instance.get('/goodsCategory/' + params.id)
// 设置佣金
export const setGoodsCommission = (id, params) => instance.put(`/goodsSpecification/${id}`, params)

export const submitExamine = (id, param) => instance.put(`/goodsAudit/${id}`, param)

// 获取专题
export const getGoodsTopic = (param) => instance.get('goodsTopic', param)

// 提交专题
export const saveSpecial = (param) => instance.post('/goodsTopic', param)

// 修改专题
export const reviseSpecial = (id, param) => instance.put(`/goodsTopic/${id}`, param)

// 获取不通状态商品的商品分类
export const getGoodsStatus = () => instance.get('/goods/status')

// 获取退货列表
export const getReturnForm = (param) => instance.get('/returnApply', param)

// 退货详情
export const getReturnDetail = (id) => instance.get(`/returnApply/${id}`)

// 退货列表统计
export const getReturnDetailStatus = () => instance.get('/returnApply/status')

// 退货原因
export const getReturnCause = (param) => instance.get('/returnCause', param)

// 提交退货原因
export const saveReturnCause = (param) => instance.post('/returnCause', param)

export const reviseReturnCause = (id, param) => instance.put(`/returnCause/${id}`, param)

// 旅游路线列表
export const getTouristes = (param) => instance.get('/travelOrder/listCount', param)

// 编辑旅游专线
export const createTravel = (params, id) => {
  // 编辑
  if (id) {
    return instance.put('/travel/' + id, params)
  // 新建
  } else {
    return instance.post('/travel', params)
  }
}

// 旅游专线列表
export const travelList = (params) => instance.get('/travel', params)

// 旅游专线统计
export const travelStatusCont = () => instance.get('/travel/status')

// 旅游专线详情
export const travelDetail = (params) => instance.get('/travel/' + params.id)

// 推送记录
export const pushlist = (params) => instance.get('/push', params)

// 推送全部
export const appPush = (params) => instance.post('/push', params)

// 广告列表
export const advertList = (params) => instance.get('/banner', params)

// 添加广告
export const saveAdvert = (params, id) => {
  // 编辑
  if (id) {
    return instance.put('/banner/' + id, params)
  // 新建
  } else {
    return instance.post('/banner', params)
  }
}

// 广告详情
export const advertDetail = (params) => instance.get('/banner/' + params.id)

// 健康专线列表
export const healthList = (params) => instance.get('/healthLine', params)

// 健康专线详情
export const healthDetail = (params) => instance.get('/healthLine/' + params.id)

// 添加健康专线
export const editHealth = (params, id) => {
  // 修改
  if (id) {
    return instance.put('/healthLine/' + id, params)  
  // 添加
  } else {
    return instance.post('/healthLine', params)  
  }
}

// 切换专线状态
export const healthChangeStatus = (params) => instance.patch('/healthLine/' + params.id)
// 获取参团人数详情列表
export const getTravelList = (param) => instance.get('/travelOrder/2019-07-15/7', param)

// 商户类型列表
export const getMerchantCategory = (param) => instance.get('/merchantCategory', param)

// 添加商户类型列表
export const addMerchantCategory = (param) => instance.post('/merchantCategory', param)

// 修改商户类型名称
export const reviseMerchantCategory = (id, param) => instance.put(`/merchantCategory/${id}`, param)

// 删除商户类型
export const deletMerchantCategory = (id) => instance.delete(`/merchantCategory/${id}`)

// 商户列表
export const getMerchant = (param) => instance.get('/merchant', param)

// 修改商户状态
export const reviseMerchantType = (id) => instance.patch(`/merchant/${id}`)

// 注册商户列表
export const rejectMerchant = (param) => instance.post('/merchant', param)

// 获取商户详情
export const merchantDetail = (id) => instance.get(`/merchant/${id}`)

// 修改商户
export const reviseMerchantl = (id, param) => instance.patch(`/merchant/${id}`, param)

// app版本列表
export const versionsList = (params) => instance.get('/appVersion', params) 

// app版本详情
export const versionsDetail = (params) => instance.get('/appVersion/' + params.id) 

// 上传apk
export const updateApk = (forms) => {
  const instance = axios.create({
    timeout: 30000,
    headers: { 'Content-Type': 'multipart/form-data'}
  })
  return instance.post('https://ticket-java.gdhttech.com/file/upload', forms)
}

// 编辑app版本 
export const editVersions = (param, id) => {
  if (id) {
    return instance.put('/appVersion/' + id, param)
  } else {
    return instance.post('/appVersion', param)
  }
}

// 系统消息列表
export const systemMessageList = (params) => instance.get('/systemMessage', params)

// 系统消息详情
export const systemMessageDetail = (params) => instance.get('/systemMessage/' + params.id)

// 编辑系统消息
export const postSystemMessage = (params, id) => {
  if (id) {
    return instance.put('/systemMessage/' + id, params)
  } else {
    return instance.post('/systemMessage', params)
  }
}

// 用户列表
export const getUserList = (param) => instance.get('/user', param)

// 用户详情
export const getUserDetail = (param) => instance.get('/user/' + param.id)

// 旅游报名人数列表
export const getTraverList = (date, id, param) => instance.get(`/travelOrder/${date}/${id}`, param)

// 旅游报名人数列表
export const getTouristOrders = (param) => instance.get('/travelOrder', param)

// 退款记录
export const returnTourist = (id, param) => instance.put(`/travelOrder/${id}`, param)

// 停止参团
export const stopGroupDate = (param) => instance.put('/travelOrder/stopGroupDate', param)

// 健康专线统计订单
export const getHealthOrders = (param) => instance.get('/healthOrder/statistics', param)

// 健康专线报名人数
export const getHealthOrdersPassengers = (id) => instance.get(`/healthOrder/passengers/${id}`) 

// 第三方健康专线
export const getHealthForeign = (param) => instance.get('/healthOrder/foreign', param)

// 管理员列表
export const getAdminList = (param) => instance.get('/admin', param)

// 添加管理员
export const addAdmin = (param) => instance.post('/admin', param)

// 修改管理员
export const reviseAdmin = (id, param) => instance.put(`/admin/${id}`, param)

// 管理员
export const adminDetail = (id) => instance.get(`/admin/${id}`)

// 删除管理员
export const deletAdmin = (id) => instance.delete(`/admin/${id}`)

// 确认退货
export const returnApply = (id, status, param) => instance.post(`/returnApply/${status}/${id}`, param)

// 商户信息
export const getMerchantInfo = (param) => instance.get('/merchant', param)

/** *************************商户端*********************** */
// 商品主题查询
export const goodsCategory = () => instance.get('/goodsCategory') 

// 商品主题查询
export const goodsTopic = () => instance.get('/goodsTopic') 

// 商户设置
export const setMerchant = (params) => instance.put('/merchant', params)


// 添加商品
export const editGoods = (params, id) => {
  if (id) {
    return instance.put('/goods/' + id, params)
  } else {
    return instance.post('/goods', params)
  }
}

// 删除规格
export const goodsSpeciDelete = (params) => instance.delete(`/goodsSpecification/${params.goodsId}/${params.id}`) 

// 物流公司列表
export const vendorsList = () => instance.get('/express/vendors')

// 订单发货
export const sendOrder = (params) => instance.put('/order/deliver/' + params.orderSn, params)

// 上下架
export const grounding = (id, status) => instance.patch(`/goods/${status}/${id}`) 

// 商品订单备注
export const remarkOrder = params => instance.patch('/order/' + params.id, params.remark)

// 充值
export const rechargeMoney = params => instance.patch(`/merchant/topUp/${params.type}/${params.amount}`)
// 充值
export const rechargeMoneyStatus = params => instance.get(`/merchant/topUp/${params.id}`)
// 商家统计信息
export const getMerchantCount = () => instance.get('/merchant/count')
export const getMerchantOrderList = (params) => instance.get('/merchant/orderList', params)
export const postWithdrawal = (params) => instance.post('/merchant/withdrawal', params)
export const topUpLog = () => instance.get('/merchant/topUp')

//导出
export const exportUrl = instance.baseURL+'order/exportExcel'

//退款订单列表
export const getRefundOrder = (params) => instance.get('/order/refundOrder',params)
//退款
export const refund = (id,type) => instance.put(`/order/refund/${type}/${id}`)

//商品名称列表
export const getGoodsName = (params) => instance.get(`/goods/getGoodsName`)